  <template>
  <div>
    <video class="fullscreen" poster="@/assets/climaxloading.jpg" id="bgvid" playsinline autoplay muted loop>
      <!-- 
    - Video needs to be muted, since Chrome 66+ will not autoplay video with sound.
    WCAG general accessibility recommendation is that media such as background video play through only once. Loop turned on for the purposes of illustration; if removed, the end of the video will fade in the same way created by pressing the "Pause" button  -->
    <!-- <source src="http://thenewcode.com/assets/videos/polina.webm" type="video/webm"> -->
    <source src="@/assets/climax.mp4" type="video/mp4">

    </video>
   <b-modal :active.sync="isModalActive">
        <h1>WE’VE REACHED OUR CLIMAX.</h1>
        <p>
        NARS House of Climax has ended, <br>thank you to all that attended. <br>You can purchase Climax Mascara <a href="https://www.narscosmetics.com/USA/explicit-black-climax-mascara/0607845070085.html" style="color: #ff1f4b !important;">here</a>.</p>
    </b-modal>
    <section class="hero is-fullheight">
      <div class="hero-head">
        <img src="@/assets/narslogo.png" class="narslogo">
      </div>
      <div class="hero-body">
        <div class="container">
          <!-- <div class="hero-text"> -->
            <!-- <div class="column is-two-thirds-mobile is-offset-2-mobile is-half-tablet is-offset-one-quarter-tablet"> -->
          <div class="info-text">
              <img class="event-logo" src="@/assets/logo.png">
              <h1>
                <span id="line1">09.20-09.22</span><br>
                <span id="line2">7PM-12AM</span><br>
                <span id="line3">22 E. 2<sup>ND</sup> ST. NY</span>
              </h1>
               <!-- <h1>
                  09.20-09.22
          7PM-12AM
                22 E. 2<sup>ND</sup> ST. NY
              </h1> -->
              <button class="button is-fullwidth is-danger" id="eventbrite-widget-modal-trigger-49790411461" type="button">Get Tickets</button>
              <!-- <a href="https://www.eventbrite.com/e/nars-house-of-climax-registration-49790411461"><button class="button is-fullwidth is-danger" type="button">Get Tickets</button></a> -->
            </div>
          </div>
      </div>
      <div class="hero-foot">
        <div class="container">
          <div class="columns">
            <div class="column is-half-tablet is-offset-one-quarter-tablet">
              <h5>Ages 21 and over</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight">
      <div class="hero-head">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns hero-text">
            <div class="column is-three-fifths is-offset-one-fifth description">
              <div class="level"></div>
              <div class="level"></div>
              <div class="level"></div>
              <div class="level"></div>
              <p>NARS Cosmetics welcomes you to the House of Climax, a world of seduction and mystique in celebration of new&nbsp;Climax&nbsp;Mascara.</p>
              <div class="level"></div>
              <div class="level"></div>
               <small>The House of Climax is a timed experience which means you must arrive within 15 minutes of your scheduled time slot. The experience takes approximately 20-30 minutes to complete. Please note that spaces are limited. If at capacity, we will revert to a first come, first served basis.
              </small>
              <div class="level"></div>
              <small>This experience is open to the public, ages 21 and over.</small>
              <div class="level"></div>
              <div class="level"></div>
              <small>GOVERNMENT-ISSUED PHOTO IDs ARE REQUIRED FOR ENTRY, AND WILL BE CHECKED&nbsp;AT&nbsp;THE&nbsp;DOOR.</small>
              <div class="level"></div>
              <div class="level"></div>
              <p>
                #NEVERFAKEIT
              </p>
            </div>
          </div>
        </div>
      </div>
          <div class="hero-foot">
            <div class="columns is-mobile is-variable is-3">
              <!-- <div class="column is-half-mobile has-text-right">
                <small>TERMS OF SERVICE</small>
              </div>
              <div class="column is-half-mobile has-text-left">
                <small>PRIVACY POLICY</small>
              </div> -->
            </div>
          </div>
    </section>
    <!-- <section class="hero is-fullheight">
      <div class="hero-head">
        <div class="container hero-text">
          <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop">
              <div class="level"></div>
              <div class="level"></div>
              <div class="level"></div>
              <div class="level"></div>
              <p>NARS Cosmetics welcomes you to the House of Climax, a world of seduction and mystique in celebration of new Climax Macara.</p>
              <div class="level"></div>
              <small>This experience is open to the public, ages 21 and over</small>
              <div class="level"></div>
              <p>
                #NEVERFAKEIT
              </p>
             
            </div>
          </div>
        </div>
      </div>
      <div class="hero-body">
      </div>  
      <div class="hero-foot">
       
      </div>
    </section> -->
 
  </div>
</template>

<script> 
  var exampleCallback = function() {
            console.log('Order complete!');
        };

        window.EBWidgets.createWidget({
            // Required
            widgetType: 'checkout',
            eventId: '49790411461',
            // iframeContainerId: 'eventbrite-widget-container-49790411461',
modal: true,
        modalTriggerElementId: 'eventbrite-widget-modal-trigger-49790411461',
            // Optional
            // iframeContainerHeight: 600,  // Widget height in pixels. Defaults to a minimum of 425px if not provided
            onOrderComplete: exampleCallback  // Method called when an order has successfully completed
        });
export default {
  name: 'Home',
  data() {
    return {
      isModalActive: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.modal-content {
  text-align: center;
  h1 {
    font-size: 44px;
    line-height: 44px;
    text-align: center;
  }
  p {
    text-align: center;
  }
 }
.narslogo {
  width: 125px;
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  // position: absolute;
  // left: 50px;
  // top: 50px;
}
.columns {
  margin-left: 0 !important;
  margin-right: 0 !important;

}
.column {

}
.description {
  padding: 0 !important;
}
 .hero-text {
  text-align: center;
 }
 .hero-foot {
  padding-bottom: 20px;
 }
 .event-logo {
  width: 100%;
 }

 button.is-danger {
  background-color: white;
  color: black;
  border-radius: 0;
  text-transform: uppercase;
  // font-family: 'Helvetica';
  font-family:'Helvetica LT W01 Light';
  // font-family:'Helvetica Neue LT W01_41488878';
  height: 62.5px;
  // font-size: 14px;
 }
 h1 {
  color: white;
  // font-size: 3vw;
  // text-align: justify;
  line-height: 36px;
  margin: 20px 0;
  // font-family: 'Helvetica';
  // font-family:'Helvetica LT W01 Light';
  // font-family:'Helvetica Neue LT W01_41488878';
  font-family:'Helvetica Neue LT W01_25 UltLt', 'Helvetica Neue', 'Helvetica';
  font-weight: 100;
  // font-weight: lighter;
  text-align: center;
 }
 h5 {
  color: white;
  text-align: center;
  text-transform: uppercase;
  font-size: 20px;
  // font-family: 'Helvetica';
  // font-family:'Helvetica LT W01 Light';
  font-family:'Helvetica Neue LT W01_41488878';
  // font-weight: lighter;
  // padding-bottom: 20px;

 }
 p, small {
  color: white;
  // font-family: 'Helvetica';
  // font-family:'Helvetica LT W01 Light';
  font-family:'Helvetica Neue LT W01_41488878';
  // font-weight: lighter;
  text-transform: uppercase;
  font-size: 20px;
  line-height: 40px;
 }
 p {
  font-size: 20px;
  line-height: 40px;
 }
 video.fullscreen { 
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // min-width: 100%;
  // min-height: 100%;
  // width: auto;
  // height: auto;
  z-index: -100;
  // transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  padding: 0;
  margin: 0;
  // left: 0px;
  // top: 0px;
  // overflow: hidden;
  object-fit: cover;
}
.info-text {
  width: 250px;
  margin: auto;
  h1 {
    line-height: 34.3px;
    #line1 {
      font-size: 45.7px;
    }
    #line2 {
      font-size: 52.8px
    }
    #line3 {
       display: block;
      margin-top: -10.7px;
      font-size: 35.7px;
      sup {
        font-size: 21.4px;  
      }
      
    }
  }
}
@media screen and (max-width: 376px) {
  .info-text {
    margin-top: -10%;
  }
  .hero-foot {
    // padding-bottom: 125px;
   }
}
@media screen and (min-width: 768px) {
  .narslogo {
    width: 125px;
    position: absolute;
    left: 50px;
    top: 50px;
    margin: 0;
  }
  .info-text {
  width: 350px;
  margin: auto;
  h1 {
    line-height: 48px;
    #line1 {
      font-size: 64px;
    }
    #line2 {
      font-size: 74px;
    }
    #line3 {
      display: block;
      margin-top: -15px;
      font-size: 50px;
      sup {
        font-size: 30px;
      }
    }
  }
  .is-danger {
    font-size: 1.4rem;
  }
}
p {
  font-size: 22px;
  line-height: 44px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue